import { useState, useEffect, useRef } from "react";
import { haptic } from "@/lib/haptic";

export const use3DButtonState = (
  isCorrect?: boolean,
  showResult?: boolean,
  onClick?: () => void
) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [color, setColor] = useState<"black" | "green" | "red">("black");
  const isProcessingClick = useRef(false);

  useEffect(() => {
    if (showResult && isCorrect !== undefined) {
      if (isCorrect) {
        setColor("green");
      } else {
        setColor("red");
        setTimeout(() => {
          setColor("black");
        }, 900);
      }
    } else if (showResult === false) {
      setColor("black");
    }
  }, [showResult, isCorrect]);

  const handleClick = () => {
    // Prevent multiple simultaneous clicks
    if (isProcessingClick.current) {
      return;
    }
    
    isProcessingClick.current = true;
    haptic.selection();
    setIsAnimating(true);
    
    // Show immediate feedback if showResult is undefined (ActivityButton3D case)
    // Wait for showResult if it's provided (WordButton3D case)
    if (isCorrect !== undefined && showResult === undefined) {
      if (isCorrect) {
        haptic.success();
        setColor("green");
      } else {
        haptic.error();
        setColor("red");
        // Reset to black after showing red for incorrect answers
        setTimeout(() => {
          setColor("black");
        }, 900);
      }
    }
    
    setTimeout(() => {
      setIsAnimating(false);
      if (onClick) {
        onClick();
      }
      // Reset the flag after the click is processed
      isProcessingClick.current = false;
    }, 300);
  };

  return {
    isAnimating,
    color,
    handleClick,
  };
}; 